import { baseApi } from './baseApi';

export const jobsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchJobs: builder.query({
      query: ({ searchTerm = '', organizationId, applicationFlow, public_job, isReferredJob }) => {
        const params = {
          search_term: searchTerm,
          organization_id: organizationId,
          public_job,
          is_referred_job: isReferredJob,
        };

        if (applicationFlow !== undefined) {
          params.application_flow = applicationFlow;
        }

        return {
          url: `/search/jobs`,
          params,
        };
      },
      providesTags: ['Jobs'],
      transformResponse: (response) => response.payload.jobs || [],
    }),
    getReferUsers: builder.query({
      query: ({ jobId, jobUuid }) => ({
        url: `/refer_users`,
        params: { job_id: jobId, job_uuid: jobUuid },
      }),
      providesTags: ['ReferUsers'],
    }),
    getUserResumes: builder.query({
      query: () => ({
        url: `/user_resumes`,
      }),
      providesTags: ['UserResumes'],
    }),
    updatePdfFile: builder.mutation({
      query: ({ id }) => ({
        url: `/pdf_files/${id}`,
        method: 'PATCH',
      }),
      invalidatesTags: ['UserResumes'],
    }),
  }),
});

export const { useSearchJobsQuery, useGetReferUsersQuery, useUpdatePdfFileMutation, useGetUserResumesQuery } = jobsApi;
